<template>
  <message-component level="warning">
    <div class="is-flex-direction-column">
      <strong><translate>Keep your invoice information up to date</translate></strong>
      <div><span v-translate="{company_name: customer.invoicing.companyName}">Are you still working at %{ company_name }?</span></div>
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <div class="buttons-wrapper">
          <button class="button is-success is-outlined is-1" v-translate @click="setupEditSameCompanyInvoiceInformation()">Yes</button>
          <button class="button is-success is-outlined is-1" v-translate @click="setupEditDifferentCompanyInvoiceInformation()">No</button>
        </div>
      </div>
    </div>
    <card-modal-component
      :show="show_modal"
      transition="fade"
      ref="modal"
      :options="{ hasOkBtn: { text: 'Save' }, hasCancelBtn: { enabled: true }}"
      @handleOk="updateInvoiceInformation($event)"
      @handleCancel="toggleModal()"
      @deactivate="toggleModal()"
      title="Update invoice information">
      <template slot="card-content">
        <form-component
          v-for="formDescriptor in formDescriptors"
          :formDescriptor="formDescriptor"
          :formData="getFormDataForDescriptor(formDescriptor)"
          :key="formDescriptor.id">
        </form-component>
      </template>
    </card-modal-component>
  </message-component>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { errorHandler, formHandlerMixin } from '@/mixins/mixins'
  import FormComponent from '@/components/form/FormComponent.vue'
  import CardModalComponent
    from '@/components/layout/modal/CardModalComponent.vue'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'invoice-information-view',
    mixins: [errorHandler, formHandlerMixin],
    components: {
      CardModalComponent,
      FormComponent,
      MessageComponent
    },
    data () {
      return {
        show_modal: false,
        redirectPath: { name: 'DashboardView' }
      }
    },
    props: {
      customer: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.customerEditModule.CustomerEditFormDescriptors,
        formDatas: state => state.customerEditModule.CustomerEditFormDatas,
        authUser: state => state.authModule.authUser
      })
    },
    methods: {
      ...mapActions([
        'setupCustomerUpdateInvoiceInformationForm',
        'setupCustomerNewInvoiceInformationForm',
        'updateCustomerInvoiceInformation',
        'errorMessage',
        'successMessage'
      ]),
      toggleModal () {
        this.show_modal = !this.show_modal
      },
      setupEditSameCompanyInvoiceInformation () {
        this.setupCustomerUpdateInvoiceInformationForm(this.authUser.profile.id).then(() => {
          this.toggleModal()
        }).catch((err) => {
          this.handleError(err)
        })
      },
      setupEditDifferentCompanyInvoiceInformation () {
        this.setupCustomerNewInvoiceInformationForm(this.authUser.profile.id).then(() => {
          this.toggleModal()
        }).catch((err) => {
          this.handleError(err)
        })
      },
      updateInvoiceInformation (btn) {
        let requestData = {
          formDatas: this.formDatas,
          profileId: this.authUser.profile.id
        }
        this.submitRequest = this.updateCustomerInvoiceInformation
        this.submitForm(requestData, btn, this.updateInvoiceInformationCallback)
      },
      updateInvoiceInformationCallback (response) {
        this.successMessage('Invoice information updated')
        this.toggleModal()
        window.location.reload()
      }
    },
    watch: {
      show_modal (val) {
        if (val) {
          this.$nextTick(() => {
            const modalCard = this.$refs.modal.$el.querySelector('.modal-card')
            if (modalCard) modalCard.style.width = '800px'
          })
        }
      }
    }
  }
</script>

<style>
.buttons-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
</style>
